import { ButtonType, ContainedButton } from 'atoms/Buttons';
import Accordian from 'atoms/Accordian/Accordian';
import { AnchorWithLink } from 'atoms/Anchor';
import FormComponent from 'atoms/FormComponent';
import ImageComponent from 'atoms/Image/index';
import { isIos, isSafari } from 'common/utilities/utils';
import {
  addRecipientGiftCardPanelHandler,
  closeExistingCardBalanceModalHandler,
  getBlackOrWhiteIcon,
  getClassNameforGoToPaymentButton,
  openExistingCardBalanceModalHandler,
  paymentButtonClickHandler,
  onRemoveRecipientGiftCardPanelHandler,
  getClassNameforAnotherRecipientButton,
  validatePreviousRecipientForm,
} from 'organisms/GiftCard/Utils/GiftCardUtils';

import GetCardDetails from '../GetCardDetails';
import PayGateCreditDebitCardHiddenForm from 'organisms/Payment/hiddenForms/PayGateCreditDebitCardHiddenForm';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { translateWithI18Next } from '@kfc-global/kfc-i18n';
import { CURRENCY_CONSTANTS, OTHER } from 'common/constants/SharedConstants';
import isEmpty from 'lodash/isEmpty';

export const getBannerPanel = giftCardDetails =>
  giftCardDetails?.segmentedGiftCardData && (
    <div className='giftcard-banner-container'>
      <div className='banner-headline'>{giftCardDetails?.segmentedGiftCardData?.headLine}</div>
      <ImageComponent
        className='banner-image'
        data-testid='product-image'
        srcFile={
          giftCardDetails?.isMobile
            ? giftCardDetails?.segmentedGiftCardData?.mobileImage
            : giftCardDetails?.segmentedGiftCardData?.desktopImage
        }
        alt='text'
      />
    </div>
  );

export const getExistingGiftCardPanel = (giftCardDetails, updateGiftCardDetails, dispatch) =>
  giftCardDetails?.segmentedGiftCardData && (
    <div className='giftcard-already-have-card-container'>
      <h1 className='giftcard-headline'>{giftCardDetails?.segmentedGiftCardData?.subHeadline}</h1>
      <div className='giftcard-description'>{giftCardDetails?.segmentedGiftCardData?.description}</div>
      <div className='resend-card-button-container'>
        <button
          data-testid='toggle-modal'
          className='button whiteButton blackBorder resendcard-details'
          onClick={() => openExistingCardBalanceModalHandler(updateGiftCardDetails, dispatch)}
        >
          {giftCardDetails?.segmentedGiftCardData?.resendCardDetailsButtonText}
        </button>
      </div>
    </div>
  );

export const getCustomerPanel = (giftCardDetails, updateGiftCardDetails) =>
  giftCardDetails?.segmentedGiftCardData && (
    <div className='yourInfoFormContainer'>
      <div className={`row row-cols-12 mt-10px`}>
        <div className='labelContent-addHope info-label pl-25px col-sm-2 col-12'>
          <span>{giftCardDetails?.segmentedGiftCardData?.yourInfoFormHeadline}</span>
        </div>

        <div className='donate-form-details px-25px col-sm-8 col-12'>
          {giftCardDetails?.customerFormConfig?.fieldsConfig?.length && (
            <div className='mt-4 contactInfoContent col-12  d-flex'>
              <div className='col-12'>
                <FormComponent
                  formConfig={{
                    ...giftCardDetails?.customerFormConfig,
                    giftCardDetails,
                    updateGiftCardDetails,
                    name: 'customer',
                    defaultValues: !isEmpty(giftCardDetails.customerDetails) ? giftCardDetails.customerDetails : {},
                    onFormLoadedCompleted: config => updateGiftCardDetails({ customerFormRef: config }),
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

export const getRecipientPanel = (giftCardDetails, updateGiftCardDetails) =>
  giftCardDetails?.segmentedGiftCardData &&
  giftCardDetails?.recipientDetails?.map((details, index) => (
    <div className='recipientForm'>
      <div className={`row row-cols-12 mt-10px`}>
        <div className='labelContent-addHope info-label-recipientForm pl-25px col-sm-2 col-12'>
          <span>{giftCardDetails?.segmentedGiftCardData?.giftCardDetailsFormHeadline}</span>
        </div>

        <div className='donate-form-details px-25px col-sm-8 col-12'>
          <div className='contactInfoContent col-12  d-flex'>
            <div className='col-12'>
              <div>
                {giftCardDetails?.recipientDetails?.length > 1 && index !== 0 && (
                  <div className='removeSection d-flex'>
                    <div
                      onClick={() => {
                        onRemoveRecipientGiftCardPanelHandler(giftCardDetails, updateGiftCardDetails, index);
                      }}
                    >
                      {translateWithI18Next(TRANSLATE_MAPPING_KEY?.REMOVE)}
                    </div>
                  </div>
                )}
              </div>
              <FormComponent
                formConfig={{
                  ...giftCardDetails?.recipientFormConfig,
                  giftCardDetails,
                  updateGiftCardDetails,
                  name: index,
                  defaultValues: { ...details, hiddenField: index },
                  enableHiddenFields: true,
                  enableDefaultDirtyFields: giftCardDetails?.removeRecipientButtonClicked,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  ));

export const getBottomPanel = (giftCardDetails, updateGiftCardDetails, dispatch) =>
  giftCardDetails?.segmentedGiftCardData && (
    <div>
      <div className='add-card-buton'>
        <button
          data-testid='toggle-modal'
          className={getClassNameforAnotherRecipientButton(giftCardDetails)}
          disabled={!validatePreviousRecipientForm(giftCardDetails)}
          onClick={() => addRecipientGiftCardPanelHandler(giftCardDetails, updateGiftCardDetails)}
        >
          {giftCardDetails?.segmentedGiftCardData?.addAnotherGiftCard}
        </button>
      </div>

      {giftCardDetails?.recipientDetails?.some(
        recipientDetail =>
          (typeof recipientDetail?.giftCardAmount !== 'undefined' &&
            recipientDetail?.giftCardAmount === OTHER &&
            recipientDetail?.customTipSelected) ||
          (typeof recipientDetail?.giftCardAmount !== 'undefined' && recipientDetail?.giftCardAmount !== OTHER),
      ) && (
        <div className={isSafari() || isIos() ? 'gift-card-summary gift-card-summary-safari' : 'gift-card-summary'}>
          {getOrderSummayJSX(giftCardDetails)}
        </div>
      )}

      {getPaymentPanel(giftCardDetails, updateGiftCardDetails, dispatch)}
      {getAdditionalInfoPanel(giftCardDetails)}
    </div>
  );

export const getPaymentPanel = (giftCardDetails, updateGiftCardDetails, dispatch) => (
  <div className='go-to-payment-button-container'>
    <ContainedButton
      data-testid='toggle-modal'
      variant={ButtonType?.primary}
      className={getClassNameforGoToPaymentButton(giftCardDetails)}
      onClick={() => paymentButtonClickHandler(giftCardDetails, updateGiftCardDetails, dispatch)}
    >
      {giftCardDetails?.segmentedGiftCardData?.goToPaymentButton}
      {giftCardDetails?.segmentedGiftCardData?.goToPaymentButton && (
        <img src={getBlackOrWhiteIcon(giftCardDetails)} className='footerIcon' alt='img' />
      )}
    </ContainedButton>
    {giftCardDetails?.isGoToPaymentButtonClicked && giftCardDetails?.giftCardPayResponse?.redirectUri && (
      <PayGateCreditDebitCardHiddenForm formData={giftCardDetails?.giftCardPayResponse} />
    )}
  </div>
);

export const getAdditionalInfoPanel = giftCardDetails =>
  giftCardDetails?.segmentedGiftCardData && (
    <div className='additionalInfo'>
      <div className='additionalInfoHeadline'>{giftCardDetails?.segmentedGiftCardData?.additionalInfoHeadline}</div>
      <div>
        <AnchorWithLink className='link-terms' href={giftCardDetails?.segmentedGiftCardData?.termsCondtionsUrl}>
          {giftCardDetails?.segmentedGiftCardData?.termsCondtionsLink}
        </AnchorWithLink>
      </div>
      <span className='additonalText'>
        {' '}
        {giftCardDetails?.segmentedGiftCardData?.faqText}
        <AnchorWithLink link className='link-faq' href={giftCardDetails?.segmentedGiftCardData?.faqUrl}>
          {giftCardDetails?.segmentedGiftCardData?.faqLink}
        </AnchorWithLink>
      </span>
    </div>
  );

export const getAmount = (amountArray, amount) => {
  const count = amountArray?.reduce((cnt, cur) => {
    cnt[cur] = cnt[cur] + 1 || 1;
    return cnt;
  }, {});
  return count?.[amount];
};
export const checkIfGiftCardAmountIsNotNaN = recipientDetail => {
  if (!isNaN(parseInt(recipientDetail?.giftCardAmount))) {
    return recipientDetail?.giftCardAmount;
  } else {
    return 0;
  }
};

export const checkIfGiftCardAmountOtherIsNotNaN = recipientDetail => {
  if (recipientDetail?.customTipSelected) {
    return recipientDetail?.giftCardAmountOther;
  } else {
    return 0;
  }
};

export const getLineItems = recipientDetail => {
  if (recipientDetail?.giftCardAmount === OTHER && recipientDetail?.customTipSelected) {
    return parseInt(recipientDetail?.giftCardAmountOther);
  } else {
    return parseInt(recipientDetail?.giftCardAmount);
  }
};

export const getGiftCardAmount = giftCardDetails => {
  return giftCardDetails?.recipientDetails?.map(recipientDetail => ({
    amount:
      recipientDetail?.giftCardAmount === OTHER
        ? checkIfGiftCardAmountOtherIsNotNaN(recipientDetail)
        : checkIfGiftCardAmountIsNotNaN(recipientDetail),
  }));
};

export const getGiftCardAmountArray = giftCardDetails => {
  return giftCardDetails?.recipientDetails.map(({ giftCardAmount, customTipSelected, giftCardAmountOther }) => {
    if (giftCardAmount !== OTHER) {
      return giftCardAmount;
    } else if (giftCardAmount === OTHER && customTipSelected) {
      return giftCardAmountOther;
    }
    return '';
  });
};

export const checqueUniqueCount = (recipientDetail, giftCardDetails) => {
  const recipientGiftCardAmount = giftCardDetails?.recipientDetails.map(({ giftCardAmount }) => giftCardAmount);
  return recipientDetailObj =>
    recipientDetail?.giftCardAmount !== OTHER
      ? recipientDetail?.giftCardAmount === recipientDetailObj?.giftCardAmount
      : recipientDetail?.customTipSelected &&
        !recipientGiftCardAmount?.includes(recipientDetail?.giftCardAmountOther) &&
        recipientDetail?.giftCardAmountOther === recipientDetailObj?.giftCardAmountOther;
};

export const getValueForGiftCardSelectedAmount = recipientDetail => {
  return recipientDetail?.giftCardAmount === OTHER
    ? recipientDetail?.giftCardAmountOther
    : recipientDetail?.giftCardAmount;
};

export const getOrderSummayJSX = giftCardDetails => {
  const giftCardAmount = getGiftCardAmount(giftCardDetails);
  const total = giftCardAmount?.reduce((acc, curr) => acc + parseInt(curr?.amount), 0);
  const giftCardAmountArray = getGiftCardAmountArray(giftCardDetails);
  const uniqueRecipientDetails = giftCardDetails?.recipientDetails?.filter((recipientDetail, index) => {
    return index === giftCardDetails?.recipientDetails?.findIndex(checqueUniqueCount(recipientDetail, giftCardDetails));
  });
  const giftCardAmounts = giftCardAmountArray.filter(Boolean);
  return (
    <Accordian
      header={`${giftCardAmounts.length} ITEM` + (giftCardAmounts.length > 1 ? 'S' : '')}
      className='global-accordian-header'
      open={true}
    >
      {uniqueRecipientDetails?.length &&
        uniqueRecipientDetails.map(
          recipientDetail =>
            (!isNaN(parseInt(recipientDetail?.giftCardAmount)) ||
              !isNaN(parseInt(recipientDetail?.giftCardAmountOther))) && (
              <section className=''>
                <div className='giftCardDescription'>
                  <div id='foodItemContainer'>
                    <span className='number'>{`${
                      getAmount(giftCardAmountArray, getValueForGiftCardSelectedAmount(recipientDetail)) > 1
                        ? getAmount(giftCardAmountArray, getValueForGiftCardSelectedAmount(recipientDetail)) + ' '
                        : 1
                    }`}</span>
                    <span id='foodNameChild' className='giftCardName'>
                      {translateWithI18Next(TRANSLATE_MAPPING_KEY?.GIFT_CARD) +
                        '- ' +
                        giftCardDetails?.currencySymbol +
                        getLineItems(recipientDetail) +
                        CURRENCY_CONSTANTS}
                    </span>
                  </div>
                  <div className='ItemPrice foodName'>
                    {giftCardDetails?.currencySymbol +
                      getAmount(giftCardAmountArray, getValueForGiftCardSelectedAmount(recipientDetail)) *
                        parseInt(
                          recipientDetail?.giftCardAmount === OTHER
                            ? recipientDetail?.giftCardAmountOther
                            : recipientDetail?.giftCardAmount,
                        ) +
                      CURRENCY_CONSTANTS}
                  </div>
                </div>
              </section>
            ),
        )}
      <div className='billDescription'>
        <div id='global-accordian-header'>
          <span className='total-header'>
            {translateWithI18Next(TRANSLATE_MAPPING_KEY?.TOTAL)?.toUpperCase() + ':'}
          </span>
        </div>
        <div className='total-amount'>{giftCardDetails?.currencySymbol + total + CURRENCY_CONSTANTS}</div>
      </div>
    </Accordian>
  );
};

export const getCardDetailsModal = (giftCardDetails, updateGiftCardDetails) =>
  giftCardDetails?.openExistingCardBalanceModal && (
    <GetCardDetails
      giftCardDetails={giftCardDetails}
      tenantId={giftCardDetails?.tenantId}
      isOpen={giftCardDetails?.openExistingCardBalanceModal}
      handleClose={event => closeExistingCardBalanceModalHandler(event, updateGiftCardDetails)}
      checkCardDetailsModalContent={giftCardDetails.segmentedGiftCardData.checkCardDetailsModalContent}
      checkCardDetailsModalTitle={giftCardDetails.segmentedGiftCardData.checkCardDetailsModalTitle}
      checkCardDetailsModalInput={giftCardDetails.segmentedGiftCardData.checkCardDetailsModalInput}
      checkCardDetailsModalButton={giftCardDetails.segmentedGiftCardData.checkCardDetailsModalButtonText}
      phoneNumberRegex={giftCardDetails.segmentedGiftCardData.phoneNumberRegex}
      customerId={giftCardDetails?.customerDetails?.customerId}
      isMobile={giftCardDetails?.isMobile}
    />
  );
